if (!customElements.get('age-verification')) {
  customElements.define(
    'age-verification',
    class AgeVerification extends HTMLElement {
      connectedCallback() {
        this.storageKey = this.dataset.storageKey || 'hypertheme:age-verification';
        this.expiryDays = parseInt(this.dataset.expiryDays, 10) || 30;
        this.declineUrl = this.dataset.declineUrl || '/';
        this.isDesignMode = this.dataset.designMode === 'true';

        this.confirmButton = this.querySelector('.age-verification__confirm');

        if (this.confirmButton) {
          this.confirmButton.addEventListener('click', this.onConfirm.bind(this));
        }

        if (this.isDesignMode) {
          this.open();
          return;
        }

        if (this.hasConfirmed()) {
          this.remove();
          return;
        }

        this.open();
      }

      hasConfirmed() {
        if (window.FoxTheme && FoxTheme.utils && typeof FoxTheme.utils.getStorage === 'function') {
          const data = FoxTheme.utils.getStorage(this.storageKey);
          return !!(data && data.confirmed);
        }

        try {
          const raw = window.localStorage.getItem(this.storageKey);
          if (!raw) return false;
          const item = JSON.parse(raw);
          if (item.expiry && new Date().getTime() > item.expiry) {
            window.localStorage.removeItem(this.storageKey);
            return false;
          }
          return !!(item.value && item.value.confirmed);
        } catch (error) {
          return false;
        }
      }

      rememberConfirmation() {
        if (window.FoxTheme && FoxTheme.utils && typeof FoxTheme.utils.setStorage === 'function') {
          FoxTheme.utils.setStorage(this.storageKey, { confirmed: true }, this.expiryDays);
          return;
        }

        try {
          window.localStorage.setItem(
            this.storageKey,
            JSON.stringify({
              value: { confirmed: true },
              expiry: new Date().getTime() + this.expiryDays * 86400000,
            }),
          );
        } catch (error) {
          /* localStorage unavailable; the gate will reappear next visit */
        }
      }

      open() {
        this.hidden = false;
        setTimeout(() => {
          this.setAttribute('active', '');
        }, 75);
        document.documentElement.classList.add('age-verification-open');
        document.body.classList.add('age-verification-open');

        if (window.FoxTheme && FoxTheme.a11y && typeof FoxTheme.a11y.trapFocus === 'function') {
          try {
            FoxTheme.a11y.trapFocus(this, this.confirmButton);
          } catch (error) {
            /* focus trap is a progressive enhancement */
          }
        }
      }

      close() {
        this.removeAttribute('active');
        document.documentElement.classList.remove('age-verification-open');
        document.body.classList.remove('age-verification-open');

        if (window.FoxTheme && FoxTheme.a11y && typeof FoxTheme.a11y.removeTrapFocus === 'function') {
          try {
            FoxTheme.a11y.removeTrapFocus();
          } catch (error) {
            /* no-op */
          }
        }

        this.hidden = true;
      }

      onConfirm() {
        if (!this.isDesignMode) {
          this.rememberConfirmation();
        }
        this.close();
      }
    },
  );
}
